import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { SalesTrendOrderGridConfigService } from 'src/app/data-grid/sales-trend-order-grid-config.service';
import { SalesTrendQtyGridService } from 'src/app/data-grid/sales-trend-qty-grid.service';
import { SalesTrendsGridConfigService } from 'src/app/data-grid/sales-trends-grid-config.service';
import { LoginModel } from 'src/app/models/login.model';
import { UpgradeFeemiumDialogComponent } from 'src/app/modules/shipyard/upgrade-feemium-dialog/upgrade-feemium-dialog.component';

@Component({
  selector: 'app-custom-grid-header',
  templateUrl: './custom-grid-header.component.html',
  styleUrls: ['./custom-grid-header.component.scss']
})
export class CustomGridHeaderComponent  implements IHeaderAngularComp,OnDestroy {
  params;
  user;
  ascSort:boolean=false;
  descSort:boolean=false;
  noSort :boolean=true;
  sort={
    valAscSort:false,
    valDescSort:false,
    trdAscSort:false,
    trdDescSort:false,
    noSort:true
  }
  @ViewChild('menuButton', { read: ElementRef }) public menuButton!: ElementRef;

  private destroy$ = new Subject<void>();
  constructor(private dialog:MatDialog,
    private salesTrendsGridConfigService:SalesTrendsGridConfigService,
    private salesTrendQtyGridService : SalesTrendQtyGridService,
    private salesTrendOrderGridConfigService: SalesTrendOrderGridConfigService) {}

  agInit(params): void {
    this.user = JSON.parse(localStorage.getItem("User")) as LoginModel;
    this.params = params;
    params.column.addEventListener(
      'sortChanged',
      this.onSortChanged.bind(this)
    );

    this.onSortChanged();
    if(this.params.column.colDef.cellRendererParams.enableMenu || this.params?.column?.userProvidedColDef?.enableMenu) {
      this.params.enableMenu= true;
    }
  }

  onMenuClicked() {
    this.params.showColumnMenu(this.menuButton.nativeElement);
  }

  onSortChanged() {
    this.ascSort = this.descSort = this.noSort = false;
    if (this.params.column.isSortAscending()) {
      this.ascSort = true;
    } else if (this.params.column.isSortDescending()) {
      this.descSort = true;
    } else {
      this.noSort = true;
    }
  }

  resetSort(){
    this.sort={
      valAscSort:false,
      valDescSort:false,
      trdAscSort:false,
      trdDescSort:false,
      noSort:true
    }
  }

  checkSort(isAsc){
    if(this.salesTrendsGridConfigService.sortModel.length){
      if(!this.salesTrendsGridConfigService.sortModel[0].colId.includes(this.params.column.colId)){
        this.resetSort();
      }
    } else if(this.salesTrendQtyGridService.sortModel.length){
      if(!this.salesTrendQtyGridService.sortModel[0].colId.includes(this.params.column.colId)){
        this.resetSort();
      }
    } else if(this.salesTrendOrderGridConfigService.sortModel.length){     
      if(!this.salesTrendOrderGridConfigService.sortModel[0].colId.includes(this.params.column.colId)){
        this.resetSort();
      }
    } else{
      this.resetSort();
    }
    if(isAsc){
      return this.params.enableSorting && (this.ascSort || this.sort.valAscSort || this.sort.trdAscSort)
    } else{
      return this.params.enableSorting && (this.descSort || this.sort.valDescSort || this.sort.trdDescSort)
    }
  }

  onSortRequested(order: 'asc' | 'desc' | null, event: any,isValue=true,key='') {
    if(this.params.enableSorting && !this.params.isSalesTrend){
      this.params.setSort(order, event.shiftKey);
    }
  }
  refresh(params: IHeaderParams) {
    return false;
  }

  onTrendSortRequested(order: 'asc' | 'desc' | null,isValue=true,key='') {
    if(this.params.enableSorting){
      this.setSorting(key,order); 
      let colId= this.params.column.getColId() + (isValue ? "" : "Diff");
      if (this.params.callback) {
        this.params.callback(this.sort.noSort ? [] : [{ colId: colId, sort: order }]);
      }     
    }
  }

  setSorting(key,order){
    const keys= Object.keys(this.sort);
    keys.forEach(element => {
      if(element == key){
        this.sort[element]=order ? true : false;        
      } else{
        this.sort[element]=false;
      }
    });
    if(!order) this.sort.noSort = true;
  }

  openFreemiumDailog(){
      this.dialog.open(UpgradeFeemiumDialogComponent, {
        width: "500px",
        disableClose: true,
        data: {},
      });
    }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
